import { Stack } from "@mui/material";

type DocumentPreviewOverlayProps = {
  open: boolean;
  momentumUrl: string;
  documentId?: number;
  onClose: () => void;
  onApprove: () => void;
  onReject: () => void;
};

export const DocumentPreviewOverlay = ({
  open,
  momentumUrl,
  documentId,
  onClose,
  onApprove,
  onReject
}: DocumentPreviewOverlayProps) => {
 
  return (
    <Stack
      direction="column"
      sx={{
        position: "fixed",
        top: 40,
        left: "30%",
        width: "950px",
        height: "790px",
        backgroundColor: "rgba(0,0,0,0.5)",
        zIndex: 2000,
        alignItems: "center",
        padding: 1
      }}
    >
      <button
        style={{
          position: "absolute",
          top: 10,
          right: 10,
          zIndex: 3000,
          padding: "5px 10px"
        }}
        onClick={onClose}
      >
        X
      </button>
      <iframe
        title="PDF Preview"
        src={`${momentumUrl}opendoc?id=${documentId}`}
        style={{
          position: "fixed",
          top: 40,
          left: "30%",
          width: "900px",
          height: "750px",
          zIndex: 99999,
          border: "none",
          overflow: "scroll"
        }}
      />
      <Stack
        direction="row"
        justifyContent="flex-end"
        sx={{
          position: "absolute",
          right: 10,
          bottom: 8,
          gap: 1,
          zIndex: 99999
        }}
      >
        <button
          style={{
            padding: "8px 15px",
            backgroundColor: "#f44336",
            color: "white",
            border: "none",
            borderRadius: 4,
            cursor: "pointer"
          }}
          onClick={onReject}
        >
          Deficient
        </button>

        <button
          style={{
            padding: "8px 15px",
            backgroundColor: "#4caf50",
            color: "white",
            border: "none",
            borderRadius: 4,
            cursor: "pointer"
          }}
          onClick={onApprove}
        >
          Approved
        </button>
      </Stack>
    </Stack>
  );
};
